<template>
  <div class="candidate-offer-list">
    <div
      v-for="(item, index) in offerRecordList"
      class="list-item-container"
      :key="index"
    >
      <div class="item-info">
        <div class="item-info-left">
          <div class="job-info">
            <div class="info">
              <div class="label">{{ $t('admin.company.offerLetterInviteRecordManagement.label.inviteOfferLetterDate') }}</div>
              <div class="container offer-time">{{ formatCreateTime(item.created_time) }}</div>
            </div>
            <div class="info">
              <div class="label">{{ $t('admin.company.offerLetterInviteRecordManagement.label.inviteCompany') }}</div>
              <div class="container company-describe">{{ item.companyI18nName }}</div>
            </div>
            <div class="info">
              <div class="label">{{ $t('admin.company.offerLetterInviteRecordManagement.label.inviteJobName') }}</div>
              <div class="container job-platform">{{ item.jobI18nName }}</div>
            </div>
          </div>
        </div>
        <div class="item-info-right">
          <div class="status-container" :class="statusMapping[item.status]" @click="handleOperate(item)">
            {{ formatStatus(item.status) }}
          </div>
        </div>
      </div>
      <div class="item-action-list">
        <div class="button-container">
          <i class="el-icon-view" @click="handleOperate(item)"></i>
          <span>{{ $t('common.btn.view') }}</span>
        </div>
      </div>
    </div>
    <div v-if="offerRecordList.length === 0" class="empty-data">{{ $t(`${i18nPrefix}.label.noOfferData`) }}</div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import moment from 'moment'
import { addI18nProperty, getConstantI18nValue } from '@/i18n'
import { OFFER_LETTER_INVITE_STATUS } from '@/constant/company'

export default {
  data () {
    return {
      i18nPrefix: 'personal.offerLetter',
      OFFER_LETTER_INVITE_STATUS,
      loading: false,
      offerRecordList: [],
      statusMapping: {
        0: 'pending',
        1: 'accept',
        2: 'reject'
      }
    }
  },
  computed: {
    companyId () {
      return this.$route.query.company_id
    }
  },
  created () {
    this.initPage()
  },
  methods: {
    ...mapActions('personal', ['getPersonalAllOfferLetter']),
    initPage () {
      this.loadOfferLetterList()
    },
    async loadOfferLetterList () {
      this.loading = true
      try {
        const resp = await this.getPersonalAllOfferLetter({ company_id: this.companyId })
        if (resp) {
          _.forEach(resp, item => {
            addI18nProperty(item, 'companyI18nName', 'job.company.cn_name', 'job.company.name')
            addI18nProperty(item, 'jobI18nName', 'job.cn_title', 'job.title')
          })
          this.offerRecordList = resp
        }
      } finally {
        this.loading = false
      }
    },
    formatCreateTime (createTime) {
      return moment(createTime).format('YYYY/MM/DD')
    },
    formatStatus (status) {
      return getConstantI18nValue(OFFER_LETTER_INVITE_STATUS, status, `${this.i18nPrefix}.INVITE_STATUS`)
    },
    handleOperate (row) {
      if (row.status === OFFER_LETTER_INVITE_STATUS.INVITED) {
        this.handleToOperateOffer(row)
      } else {
        this.handleViewOfferDetail(row)
      }
    },
    handleToOperateOffer (row) {
      this.$router.replace({
        path: '/recruiting/personal/offer-letter/edit',
        query: {
          job_id: row.job.id,
          candidate_id: row.candidate.id,
          invite_id: row.id,
          company_id: row.job.company.id
        }
      })
    },
    handleViewOfferDetail (row) {
      this.$router.push({ path: `/recruiting/personal/offer-letter/${row.id}/detail`, query: { company_id: row.job.company.id } })
    }
  }
}
</script>

<style lang="scss" scoped>
.candidate-offer-list {
  .list-item-container {
    margin: 10px 10px 20px 10px;
    color: #909090;

    > div {
      background: #fff;
    }

    .item-info {
      padding: 15px 20px;
      display: flex;
      border-radius: 4px;

      .item-info-left {
        flex: 2.4;

        > div {
          display: flex;
          flex-direction: column;

          > span {
            overflow: hidden;
            word-break: keep-all;
            white-space: nowrap;
            text-overflow: ellipsis;
            max-width: 200px;
          }
        }

        .job-info {
          color: #757575;

          .info {
            margin-bottom: 8px;
            .label {
              font-size: 14px;
              margin-bottom: 2px;
            }
          }

          .container {
            color: #a9a9a9;
          }

          .job-platform {
            font-size: 12px;
          }
        }
      }

      .item-info-right {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;

        .status-container {
          margin: 25px 0 10px 0;
          background-color: #e3f3e9;
          height: 80px;
          width: 80px;
          padding: 5px;
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;

          &.pending {
            background-color: #ffe8e2;
            color: #ff7041;
          }

          &.accept {
            color: #44a96a;
          }

          &.reject {
            color: #696969;
            background-color: #e9e9e9;
          }
        }
      }
    }
    .item-action-list {
      margin-top: 5px;
      display: flex;
      padding: 10px 20px;
      justify-content: space-around;

      .button-container {
        text-align: center;
        width: 40px;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        align-items: center;

        > i {
          font-size: 27px;
        }

        .iconfont {
          font-size: 25px;
        }
      }
    }
  }

  .empty-data {
    text-align: center;
    font-size: 14px;
    color: #606266;
    margin-top: 10px;
  }
}
</style>
